import graphql__5f6d1d2483d08441b579 from "./__generated__/LaunchMarketingEmailDialog_marketingEmail.graphql.ts";
import graphql__11c80f0d2219abdbf112 from "./__generated__/LaunchMarketingEmailDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import FormDialog from "./FormDialog";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";
import {useIntl} from "react-intl";
import type {LaunchMarketingEmailDialogMutation} from "./__generated__/LaunchMarketingEmailDialogMutation.graphql";

type Props = {
    queryRef: any,
    handleCloseDialog: () => void
}

const LaunchMarketingEmailDialog: React.FC<Props> = ({queryRef, handleCloseDialog}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const marketingEmail = useFragment(
        graphql__5f6d1d2483d08441b579,
        queryRef
    );

    const recipientCount = marketingEmail.mailingList?.subscribedCount ?? 0;
    const canLaunch = recipientCount > 0;

    const handleSubmission = () => {
        commitMutationWithErrorHandling<LaunchMarketingEmailDialogMutation>(
            relayEnvironment,
            {
                mutation: graphql__11c80f0d2219abdbf112,
                variables: {
                    input: {
                        id: marketingEmail.id
                    }
                },
                onCompleted: () => {
                    handleCloseDialog();
                },
                onError: (error) => {
                    console.error(error);
                    handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToLaunchMarketingEmail'})
            }
        )
    }

    return (
        <FormDialog
            handleCloseDialog={handleCloseDialog}
            handleSubmission={handleSubmission}
            initialValues={{}}
            headline={intl.formatMessage({id: 'dialog.LaunchMarketingEmailDialog.headline'})}
            submitLabel={intl.formatMessage({id: 'button.launch'})}
            dangerous={true}
            disabled={!canLaunch}
        >
            <div className="space-y-4">
                <p className="text-gray-600">
                    {intl.formatMessage({id: 'dialog.LaunchMarketingEmailDialog.confirmMessage'})}
                </p>
                <dl className="divide-y divide-gray-200 border border-gray-200 rounded-md">
                    <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4">
                        <dt className="text-sm font-medium text-gray-500">{intl.formatMessage({id: 'marketingEmail.field.name'})}</dt>
                        <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">{marketingEmail.name}</dd>
                    </div>
                    <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4">
                        <dt className="text-sm font-medium text-gray-500">{intl.formatMessage({id: 'marketingEmail.field.mailingList'})}</dt>
                        <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">{marketingEmail.mailingList?.name}</dd>
                    </div>
                    <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4">
                        <dt className="text-sm font-medium text-gray-500">{intl.formatMessage({id: 'marketingEmail.field.emailTemplate'})}</dt>
                        <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">{marketingEmail.emailTemplate?.name}</dd>
                    </div>
                    <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4">
                        <dt className="text-sm font-medium text-gray-500">{intl.formatMessage({id: 'marketingEmail.field.recipientCount'})}</dt>
                        <dd className={"mt-1 text-sm sm:col-span-2 sm:mt-0 font-bold " + (recipientCount === 0 ? "text-red-600" : "text-gray-900")}>{recipientCount}</dd>
                    </div>
                </dl>
                {!canLaunch && (
                    <p className="text-sm text-red-600">
                        {intl.formatMessage({id: 'dialog.LaunchMarketingEmailDialog.noRecipients'})}
                    </p>
                )}
                {canLaunch && (
                    <p className="text-sm text-amber-600">
                        {intl.formatMessage({id: 'dialog.LaunchMarketingEmailDialog.warning'})}
                    </p>
                )}
            </div>
        </FormDialog>
    )
}

export default LaunchMarketingEmailDialog;
